import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["person-avatar-item", { 'person-avatar-item--selected': _ctx.selected }])
  }, [
    _createVNode(_component_q_avatar, {
      size: _ctx.size,
      color: "grey-3",
      "text-color": "grey-6",
      class: "cursor-pointer person-avatar-item__avatar",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
    }, {
      default: _withCtx(() => [
        (_ctx.person.primaryFace && _ctx.person.primaryFace.imageUrl)
          ? (_openBlock(), _createBlock(_component_q_img, {
              key: 0,
              src: _ctx.person.primaryFace.imageUrl,
              ratio: 1,
              fit: "cover"
            }, {
              error: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "fa fa-user",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["src"]))
          : (_openBlock(), _createBlock(_component_q_icon, {
              key: 1,
              name: "fa fa-user",
              size: "sm"
            })),
        _createVNode(_component_q_tooltip, {
          delay: 300,
          offset: [0, 6]
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass({ 'text-grey-5': !_ctx.person.label })
            }, _toDisplayString(_ctx.person.label || 'Unnamed'), 3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["size"]),
    (_ctx.person.faceCount)
      ? (_openBlock(), _createBlock(_component_q_badge, {
          key: 0,
          color: "primary",
          floating: "",
          class: "face-count-badge"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.person.faceCount), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}